import { apiFetch } from './client';

export type ResellerEmailMode = 'platform' | 'own' | 'null';

export type ResellerEmailOwnBody =
  | { provider: 'sendgrid'; credentials: { apiKey: string; from: string } }
  | { provider: 'gmail_smtp'; credentials: { email: string; appPassword: string } }
  | {
      provider: 'smtp';
      credentials: {
        host: string;
        port: number;
        secure: boolean;
        user: string;
        password: string;
        from: string;
      };
    };

export type ResellerEmailPutBody =
  | { mode: 'platform' }
  | { mode: 'null' }
  | { mode: 'own'; own: ResellerEmailOwnBody };

export interface ResellerEmailView {
  mode: ResellerEmailMode;
  own: {
    provider: 'sendgrid' | 'gmail_smtp' | 'smtp' | null;
    credentials_redacted: Record<string, string> | null;
  };
  /** Super-admin global "allow any reseller to use platform" switch. */
  platform_allow_reseller_use: boolean;
  /** Per-reseller switch set by super-admin from the reseller detail page. */
  per_reseller_platform_allowed: boolean;
  /** true when both global and per-reseller switches are on. */
  platform_effective_available: boolean;
}

export const resellerEmailSettings = {
  get: (resellerId: string) =>
    apiFetch<ResellerEmailView>(`/api/resellers/${resellerId}/email-settings`),
  put: (resellerId: string, body: ResellerEmailPutBody) =>
    apiFetch<{ ok: true }>(`/api/resellers/${resellerId}/email-settings`, {
      method: 'PUT',
      body: JSON.stringify(body),
    }),
  /** Super-admin toggle of per-reseller platform-email gate. */
  setPlatformAllowed: (resellerId: string, allowed: boolean) =>
    apiFetch<{ ok: true; allowed: boolean }>(
      `/api/resellers/${resellerId}/email-settings/platform-allowed`,
      { method: 'PATCH', body: JSON.stringify({ allowed }) },
    ),
};
